import React, { useState } from 'react';
import { SectionTitle } from '../../../components/SectionTitle';
import { FlexWrapper } from '../../../components/FlexWrapper';
import { Work } from './work/Work';
import socialImg from './../../../assets/images/Proj 1.png'
import timerImg from './../../../assets/images/Proj 2.png'
import { Container } from '../../../components/Container';
import { TabMenu, TabsStatusType } from './tabMenu/TabMenu';
import {S} from './Works_Styles'
import {AnimatePresence, motion} from 'framer-motion'

// const tabsItems = ["All", "Landing page", "React", "SPA"]

const tabsItems:Array<{title: string, status: TabsStatusType}>  = [
    {
        title: "All",
        status: "all"
    },
    {
        title: "Landing page",
        status: "Landing"
    },
    {
        title: "React",
        status: "react" /* статусы обязательно должны совпадать с типами в проектах */
    },
    {
        title: "SPA",
        status: "spa"
    }
]

const worksData = [
    {
        title:"Social Works",
        src: socialImg,
        text:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi hic explicabo cupiditate, earum non iste.",
        type: "spa",
        id: 1
    },
    {
        title:"Timer",
        src: timerImg,
        text:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi hic explicabo cupiditate, earum non iste.",
        type: "react",
        id: 2
    },
    {
        title:"Social Works",
        src: socialImg,
        text:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi hic explicabo cupiditate, earum non iste.",
        type: "spa",
        id: 3
    },
    {
        title:"Timer",
        src: timerImg,
        text:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi hic explicabo cupiditate, earum non iste.",
        type: "react",
        id: 4
    },
    {
        title:"Social Works",
        src: socialImg,
        text:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi hic explicabo cupiditate, earum non iste.",
        type: "spa",
        id: 5
    },
    {
        title:"Timer",
        src: timerImg,
        text:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi hic explicabo cupiditate, earum non iste.",
        type: "react",
        id: 6
    }
] 

export const Works: React.FC = () => {
    const [currentFilterStatus, setCurrentFilterStatus] = useState("all")
    let filteredWorks = worksData

    if (currentFilterStatus === "Landing") {
        filteredWorks = worksData.filter(work => work.type === "Landing")
    }
    if (currentFilterStatus === "react") {
        filteredWorks = worksData.filter(work => work.type === "react")
    }
    if (currentFilterStatus === "spa") {
        filteredWorks = worksData.filter(work => work.type === "spa")
    } 

    function changeFilterStatus(value:TabsStatusType) {
        setCurrentFilterStatus(value)
    }


    return (
        <S.Works id={"works"}>
            <Container>
            <SectionTitle>My Works</SectionTitle>
            <TabMenu tabsItems={tabsItems} 
                     changeFilterStatus={changeFilterStatus}
                     currentFilterStatus={currentFilterStatus}/>
            <FlexWrapper justify={"space-between"} align={"flex-start"} wrap="wrap">
                <AnimatePresence>
                {filteredWorks.map((w)=> {
                    return (
                        <motion.div style={{width: "400px", flexGrow: 1,maxWidth: "540px"}}
                        layout
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        key={w.id}
                        >
                        <Work title={w.title}
                              src={w.src} 
                              text={w.text} 
                              key={w.id} 
                        />
                        </motion.div>
                    )
                })} 
                </AnimatePresence>
                
            </FlexWrapper>
            </Container>
        </S.Works>
    );
};

